// listFilter.js
import $ from "jquery";

const allCategories = window.allCategories || {};
const isWorkshopFilter = window.location.href.includes("workshops");

const filters = {
  name: "*name",
  status: "status",
  category: isWorkshopFilter ? "category_ids" : "category_id",
  city: "city_id",
};

// --- Универсальные селекторы (desktop + mobile)
const UI = {
  // контейнеры фильтров
  roots: ".orders__filter, .mobile-filters",

  // категории
  categoryInputs:
    ".orders__filter .category input, .mobile-filters .category input",
  allCategoriesInputs: "#all__categories, #mob_all__categories",

  // статусы
  statusInputs: ".orders__filter .status input, .mobile-filters .status input",
};

const ROOTS = ".orders__filter, .mobile-filters";

function uniq(arr) {
  return [...new Set((arr || []).map(String))];
}

function getAllKeys() {
  return Object.keys(allCategories).map(String);
}

function syncCategoryUI(values) {
  const set = new Set(values.map(String));
  const allKeys = getAllKeys();

  // синхронно проставляем во всех UI (desktop + mobile)
  $(UI.categoryInputs).each(function () {
    $(this).prop("checked", set.has(String($(this).val())));
  });

  const isAll =
    values.length === allKeys.length &&
    values.every((id) => allKeys.includes(String(id)));

  $(UI.allCategoriesInputs).prop("checked", isAll);
}

const PRETEND_ALL_CATS_KEY = "pretendAllCatsUI";

// --- Разбор текущих query ---
const url = String(window.location);
const rawQuery = url.split("?")[1] || "";
const params = Object.fromEntries(new URLSearchParams(rawQuery));
export let newParamsObj = {};

// Парсим параметры (поддержка JSON-массивов)
Object.keys(params).forEach((item) => {
  const v = params[item];
  try {
    if (typeof v === "string" && v.startsWith("[") && v.endsWith("]")) {
      newParamsObj[item] = JSON.parse(v);
    } else {
      newParamsObj[item] = v;
    }
  } catch {
    newParamsObj[item] = v;
  }
});

// --- Хелперы ---
function formatKeyword(value) {
  const s = String(value || "").trim();
  if (!s) return "";
  if (s.startsWith("%") && s.endsWith("%")) return s;
  return "%" + s + "%"; // оборачиваем, энкодим целиком ниже
}

function markPretendAllCatsOn() {
  sessionStorage.setItem(PRETEND_ALL_CATS_KEY, "1");
}
function clearPretendAllCats() {
  sessionStorage.removeItem(PRETEND_ALL_CATS_KEY);
}
function isPretendAllCatsOn() {
  return sessionStorage.getItem(PRETEND_ALL_CATS_KEY) === "1";
}

function setUICategoriesAllChecked() {
  $(UI.categoryInputs).prop("checked", true);
  $(UI.allCategoriesInputs).prop("checked", true);
}

function setUICategoriesFromURL() {
  const currentCategoryIds = newParamsObj[`filter[${filters.category}]`];

  // сбрасываем все
  $(UI.categoryInputs).prop("checked", false);
  $(UI.allCategoriesInputs).prop("checked", false);

  // если явно 0 -> ничего не выбрано
  if (
    Array.isArray(currentCategoryIds) &&
    currentCategoryIds.length === 1 &&
    String(currentCategoryIds[0]) === "0"
  ) {
    return;
  }

  // если выбраны все
  const allKeys = Object.keys(allCategories).map(String);
  if (
    Array.isArray(currentCategoryIds) &&
    allKeys.length &&
    currentCategoryIds.map(String).length === allKeys.length &&
    currentCategoryIds.map(String).every((id) => allKeys.includes(id))
  ) {
    $(UI.allCategoriesInputs).prop("checked", true);
    $(UI.categoryInputs).prop("checked", true);
    return;
  }

  // иначе — отмечаем по списку
  if (Array.isArray(currentCategoryIds)) {
    const set = new Set(currentCategoryIds.map(String));
    $(UI.categoryInputs).each(function () {
      $(this).prop("checked", set.has(String($(this).val())));
    });
  }
}

export function assignNewUrl(paramsObj) {
  // если есть категории — добавляем or=true, иначе убираем
  const hasCategories =
    Object.prototype.hasOwnProperty.call(paramsObj, "filter[category_id]") ||
    Object.prototype.hasOwnProperty.call(paramsObj, "filter[category_ids]");

  if (isWorkshopFilter && hasCategories) {
    paramsObj["filter[or]"] = "true";
  } else {
    delete paramsObj["filter[or]"];
  }

  const queryParts = [];

  Object.keys(paramsObj).forEach((key) => {
    const val = paramsObj[key];
    let out;

    if (Array.isArray(val)) {
      out = JSON.stringify(val); // отдаём JSON без дополнительного энкодинга
    } else if (key === `filter[${filters.name}]`) {
      out = encodeURIComponent(formatKeyword(val)); // %...% + энкод целиком
    } else {
      out = encodeURIComponent(String(val ?? ""));
    }

    queryParts.push(`${key}=${out}`);
  });

  const baseUrl = `${location.origin}${location.pathname}`;
  const query = queryParts.join("&");
  const finalUrl = query ? `${baseUrl}?${query}` : baseUrl;
  window.location.assign(finalUrl);
}

// Сбрасываем всё и оставляем только один выбранный фильтр.
// Если pretendAllCats = true и isWorkshopFilter = true → категории в URL не пишем,
// но в UI показываем «все включены» (через флаг в sessionStorage).
function setOnlyFilter(key, value, { pretendAllCats = false } = {}) {
  newParamsObj = {};
  if (key && value !== undefined && value !== null && String(value).length) {
    newParamsObj[key] = value;
  }

  if (isWorkshopFilter && pretendAllCats) {
    // гарантируем, что категории не попадут в URL
    delete newParamsObj["filter[category_id]"];
    delete newParamsObj["filter[category_ids]"];
    delete newParamsObj["filter[or]"];
    markPretendAllCatsOn();
  } else {
    clearPretendAllCats();
  }

  assignNewUrl(newParamsObj);
}

// ------------------ Обработчики ------------------

// ПОИСК ПО ИМЕНИ
$(document).on("click", ".orders__search-button", function (e) {
  e.preventDefault();
  const keyword = $("#keywords").val();
  if (isWorkshopFilter) {
    setOnlyFilter(`filter[${filters.name}]`, keyword, { pretendAllCats: true });
  } else {
    newParamsObj[`filter[${filters.name}]`] = keyword;
    assignNewUrl(newParamsObj);
  }
});

$(document).on("keydown", "#keywords", function (e) {
  if (e.key === "Enter") {
    e.preventDefault();
    const keyword = $("#keywords").val();
    if (isWorkshopFilter) {
      setOnlyFilter(`filter[${filters.name}]`, keyword, {
        pretendAllCats: true,
      });
    } else {
      newParamsObj[`filter[${filters.name}]`] = keyword;
      assignNewUrl(newParamsObj);
    }
  }
});

// СТАТУС
$(document).on("click", UI.statusInputs, function () {
  const isChecked = $(this).prop("checked");
  const clickedValue = $(this).val();

  if (isWorkshopFilter) {
    if (isChecked) {
      $(UI.statusInputs).not(this).prop("checked", false);
      setOnlyFilter(`filter[${filters.status}]`, clickedValue, {
        pretendAllCats: true,
      });
    } else {
      setOnlyFilter(null, null, { pretendAllCats: true });
    }
  } else {
    if (isChecked) {
      newParamsObj[`filter[${filters.status}]`] = clickedValue;
      $(UI.statusInputs).not(this).prop("checked", false);
    } else {
      delete newParamsObj[`filter[${filters.status}]`];
    }
    assignNewUrl(newParamsObj);
  }
});

// ГОРОД
$(document).on("change", "#filter_sidebar #city_id", function () {
  const city = $("#city_id").val();
  if (isWorkshopFilter) {
    setOnlyFilter(`filter[${filters.city}]`, city, { pretendAllCats: true });
  } else {
    newParamsObj[`filter[${filters.city}]`] = city;
    assignNewUrl(newParamsObj);
  }
});

// КАТЕГОРИИ (реально пишем в URL и выключаем режим «сыграем будто все включены»)
$(document).on("change", UI.categoryInputs, function () {
  clearPretendAllCats();
  delete newParamsObj["page"];

  // берем только из того блока, где кликнули
  const $root = $(this).closest(ROOTS);

  const values = uniq(
    $root
      .find(".category input:checked")
      .map(function () {
        return this.value;
      })
      .get(),
  );

  // синхронизируем второй блок (чтобы было одинаково)
  syncCategoryUI(values);

  // пишем в URL
  const out = values.length ? values : ["0"];

  if (isWorkshopFilter) {
    setOnlyFilter(`filter[${filters.category}]`, out, {
      pretendAllCats: false,
    });
  } else {
    newParamsObj[`filter[${filters.category}]`] = out;
    assignNewUrl(newParamsObj);
  }
});

// «Все категории»
$(document).on("change", UI.allCategoriesInputs, function (e) {
  // защита: реагируем только на реальный input
  if (e.target !== this) return;

  clearPretendAllCats();

  const checked = $(this).prop("checked");

  // синхронно ставим галку на второй чекбокс
  $(UI.allCategoriesInputs).prop("checked", checked);

  const allKeys = Object.keys(allCategories).map(String);

  // отмечаем/снимаем все категории в обоих блоках
  $(UI.categoryInputs).prop("checked", checked);

  if (isWorkshopFilter) {
    setOnlyFilter(`filter[${filters.category}]`, checked ? allKeys : ["0"], {
      pretendAllCats: false,
    });
  } else {
    newParamsObj[`filter[${filters.category}]`] = checked ? allKeys : ["0"];
    assignNewUrl(newParamsObj);
  }
});

// ------------ Инициализация UI -------------
const currentStatus = newParamsObj[`filter[${filters.status}]`];
if (currentStatus) {
  $(UI.statusInputs).prop("checked", false);
  $(`${UI.statusInputs}[value="${currentStatus}"]`).prop("checked", true);
}

$(document).on("click", ".mobile-filters__toggle", function () {
  $("#mobileFiltersCollapse").collapse("hide");
});

// Категории: если включён режим «притвориться, что все включены» — рисуем так.
// Иначе — как обычно по URL.
if (isWorkshopFilter && isPretendAllCatsOn()) {
  setUICategoriesAllChecked();
} else {
  setUICategoriesFromURL();
}

// --- Кнопка очистки поиска (если она на этой странице) ---
$(".reusable__input-no-style").each((_, reusableItem) => {
  const $wrap = $(reusableItem);
  if (!$wrap.find(".clear__button").length) return;

  const curInput = $wrap.find("input");
  const clearButton = curInput.parent().find(".clear__button");

  // Показ/скрытие кнопки по наличию текста
  if ((curInput.val() || "").length > 0) {
    clearButton.show();
  }
  curInput.on("input", function () {
    if ($(this).val().length > 0) {
      clearButton.show();
    } else {
      clearButton.hide();
    }
  });

  // Очистка поиска
  clearButton.on("click", function () {
    curInput.val("");
    clearButton.hide();

    // удаляем поиск
    delete newParamsObj[`filter[*name]`];

    if (isWorkshopFilter) {
      // включаем режим «в UI все категории включены», но в URL их нет
      markPretendAllCatsOn();
      delete newParamsObj["filter[category_id]"];
      delete newParamsObj["filter[category_ids]"];
      delete newParamsObj["filter[or]"];
    }

    assignNewUrl(newParamsObj);
  });
});

$(".reset__filters").on("click", function (e) {
  e.preventDefault();

  if (isWorkshopFilter) {
    setOnlyFilter(`filter[${filters.category}]`, Object.keys(allCategories), {
      pretendAllCats: false,
    });
  } else {
    newParamsObj[`filter[${filters.category}]`] = Object.keys(allCategories);
    assignNewUrl(newParamsObj);
  }
});
